module.exports = {"411771360":"关王庙乡","411771400":"驻马店市职教园区","411771560":"金河街道","411771562":"金山街道","411771563":"开源街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411771.json
// module id = 1819
// module chunks = 0